import { createFileRoute } from "@tanstack/react-router"
import { BackofficeTopicConversationsSheet } from "modules/backoffice/components/knowledge/BackofficeTopicConversationsSheet"

export const Route = createFileRoute("/_base/_auth/backoffice/knowledge/topics/$topicId")({
  component: TopicConversations,
})

function TopicConversations() {
  const { topicId } = Route.useParams()
  const navigate = Route.useNavigate()
  const search = Route.useSearch()
  return (
    <BackofficeTopicConversationsSheet
      key={topicId}
      topicId={topicId}
      onClose={() => {
        void navigate({ to: "/backoffice/knowledge", search })
      }}
    />
  )
}
